import script from "./expenselist.vue?vue&type=script&setup=true&lang=js"
export * from "./expenselist.vue?vue&type=script&setup=true&lang=js"

import "./expenselist.vue?vue&type=style&index=0&id=ed79cf84&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed79cf84"]])

export default __exports__